import React from "react";
import car from '../../assets/games/car.png'
import "./index.css";
const Page = () => {
  const itemRender = (item) => (
    <div className="content" key={item.name_en}>
      <img alt="游戏" src={item.img} />
      <div className="name-zh">{item.name_zh}</div>
      <div className="desc">
        <div className="desc_label">{item.desc}</div>
        <div className="tags">
          {item.tags.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </div>
    </div>
  );

  const list = [
    {
      img: car,
      name_en: "IDLE ADVENTURERS",
      name_zh: "我是列车长",
      desc: "融合 Roguelike 元素的塔防休闲游戏，带来别具一格的策略体验。玩家选择不同的强化效果，升级列车并赋予其多样化的攻击手段，以应对不断来袭的敌人。每一次强化都将带来新的战斗策略和可能性。策略与运气并存，击败所有敌人并成功守卫列车，使用你的塔防智慧赢得最终胜利。",
      tags: ["塔防", "休闲", "Roguelike"],
    },
  ];

  return (
    <div className="games-container">
      <div className="games-header">游戏</div>
      <div className="content-wrap">{list.map((item) => itemRender(item))}</div>
    </div>
  );
};

export default Page;
